import React, { useState } from "react";
import Input from "../../UI/Input/Input";
import LanguageIcon from "@mui/icons-material/Language";
import Select from "../../UI/Select/Select";
import BaseButton from "../../UI/BaseButton/BaseButton";
import { useEffect } from "react";
import { getCustomerAccount, postFees, getDomain } from "../../../util/API/transfer";
import { useSelector } from "react-redux";
import CustomAlert from "../../UI/CustomAlert/CustomAlert";
import { CircularProgress, Stack } from "@mui/material";
import PinPad from "../../PinPad/PinPad";
import Box from "@mui/material/Box";

function Fees() {
  const [inputValue, setInputValue] = useState("");
  //TODO: Replace with actual sender name
  // const [senderName, setSenderName] = useState("");
  const [selectedOption, setSelectedOption] = useState({
    account: "",
    description: ""
  });
  const [transactionInformation, setTransactionInformation] = useState([]);
  const [fee, setFee] = useState(0.0);
  const [total, setTotal] = useState(0.0);
  const [showAlert, setShowAlert] = useState(false);
  const [severity, setSeverity] = useState("error");
  const [message, setMessage] = useState("");
  const [header, setHeader] = useState("");
  const [receipt, setReceipt] = useState(false);
  const [receiptIDData, setReceiptIDData] = useState({});
  const [disabled, setDisabled] = useState(false);
  const [feeDescription, setFeeDescription] = useState([]);
  const [showPinPad, setShowPinPad] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  const user = useSelector((state) => state.usersList.userID);
  let data = JSON.parse(sessionStorage.getItem("user"));
  let pin = sessionStorage.getItem("pin");
  let agent = JSON.parse(sessionStorage.getItem("user")).payload?.body;
  const parentuserid = sessionStorage.getItem("parentuserid");
  let isOperator = sessionStorage.getItem("isOperator");

  // Dummy function to calculate fee, this should be replaced with actual logic
  const calculateFee = () => {
    // Set static fee for demonstration purposes
    const calculatedFee = 0.0;
    setFee(calculatedFee);
    setTotal(parseFloat(inputValue) - calculatedFee);
  };

  const getAccounts = async () => {
    const response = await getCustomerAccount(user['User'].id);
      const records = response.ServiceData.record.filter(
        (record) => record.Vtransfersourcepis.piid === "229"
      );

      // Filter out duplicates based on unique identifiers (e.g., account ID)
      const uniqueRecords = records.filter(
        (record, index, self) =>
          index === self.findIndex(
            (r) => r.Vtransfersourcepis.acctID === record.Vtransfersourcepis.acctID
          )
      );

      setTransactionInformation(uniqueRecords);
  };

  const getDomains = async() => {
    const response = await getDomain().then((response) => {
      if (response) {
        const descriptionOptions = response.payload?.body.record.map((type) => ({
          key: type.domainattributes.other1,
          value: type.domainattributes.domainatt,
          label: type.domainattributes.attname
        }));
        setFeeDescription(descriptionOptions);
      }
    })
  }

  useEffect(() => {
    getAccounts();
  }, []);

  useEffect(() => {
    getDomains();
  }, [])

  const options = transactionInformation.map((record) => ({
    key: record.Vtransfersourcepis.acctID,
    value: record.Vtransfersourcepis.friendlyname,
    label: record.Vtransfersourcepis.friendlyname + " - " + record.Vtransfersourcepis.currcode + " " + record.Vtransfersourcepis.balance
  }));

  useEffect(() => {
    if (options) {
      setSelectedOption({...selectedOption, account: options[0]?.value});
    }
  }, [])
// }, [options])

  const handleConfirm = (event, pin) => {
    let PIN = pin.join('');
    handlePostFees(event, PIN);
    setShowPinPad(false);
  };

  const pinConfiguration = useSelector((state) => state.login.pinConfiguration);
  // console.log(pinConfiguration)

  const handlePostFees = async (event, pin) => {
    // Logic to handle deposit

    if (!inputValue) {  
      setShowAlert(true);
      setSeverity("error");
      setMessage("Please enter a value to be deposited");
      setHeader("Error");
      return;
    }

    if (!selectedOption['description']) {
      setShowAlert(true);
      setSeverity("error");
      setMessage("Please select the reason for paying the fee");
      setHeader("Error");
      return;
    }

    event.preventDefault();
    try{
      setIsLoading(true);
      const response = await postFees(
        transactionInformation[0]['Vtransfersourcepis'].id,
        user['User'].id,
        user['User'].accountID,
        parseFloat(inputValue),
        feeDescription.filter((description) => description.value === selectedOption['description'])[0].key, 
        feeDescription.filter((description) => description.value === selectedOption['description'])[0].label, 
        data.payload?.body.User.firstName,
        data.payload?.body.User.lastName,
        user['User'].firstName,
        user['User'].lastName,
        transactionInformation[0]['Vtransfersourcepis'].acctID,
        agent['User'].id, // agent
        agent['User'].firstName, // agent
        agent['User'].lastName, // agent
        pin,
        parentuserid,
        isOperator
      ).then((response) => {
        setReceipt(true);
        // console.log(response); 
        if(response.Status === "1") {
        setReceiptIDData(response);
        setDisabled(true);
        setShowAlert(true);
        setSeverity("success");
        setMessage("Fee Withdrawal Completed");
        // setMessage("Fee Deposit Completed");
        setHeader("Congratulations!");

        if (pinConfiguration === "once") {
          sessionStorage.setItem("pin", pin);
        }

        setInputValue("");
        // setSelectedOption({...selectedOption, description: feeDescription[0]?.value});
        }
        else {
          setShowAlert(true);
          setSeverity("error");
          setMessage("Deposit Failed: " + response.payload.msg);
          setHeader("Error!");
        }
      });
    }
    catch(error){
    } finally {
      setIsLoading(false);
    }

    getAccounts();
  };

  const handleFeeTransfer = () => {
    if (!inputValue || parseFloat(inputValue) === 0) {  
      setShowAlert(true);
      setSeverity("error");
      setMessage("Please enter a value greater than 0 to be deposited");
      setHeader("Error");
      return;
    }

    if (!selectedOption['description']) {
      setShowAlert(true);
      setSeverity("error");
      setMessage("Please select the reason for paying the fee");
      setHeader("Error");
      return;
    }

    setShowPinPad(true);
  }

  return (
    <Box className="consumer-deposit-container">
        <Box className="d-flex justify-content-center gap-3 align-items-center">
          <LanguageIcon />
          <Box className="header">Fees</Box>
        </Box>

        {isLoading == true ? (
          <Box
              sx={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  width: "100%",
                  overflow: "hidden",
              }}
          >
              <CircularProgress />
          </Box>
        ) : (
          <Box className="customer-deposit-inputs">
            <form>
                <Select
                  name="account"
                  label="Account"
                  value={selectedOption['account']}
                  onChange={(e) => setSelectedOption((prev) => ({ ...prev, account: e.target.value }))}
                  options={options}
                />
                <Input
                  name="feeAmount"
                  label="Fee Amount"
                  value={inputValue}
                  type="number"
                  textAlign="right"
                  // onChange={(e) => setInputValue(e.target.value)}
                  onChange={(e) => {
                    const newValue = e.target.value;
                    // Allow empty string for deletion or only non-negative numbers
                    if (newValue === "" || (!isNaN(newValue) && Number(newValue) >= 0)) {
                      setInputValue(newValue);
                    } else {
                      setShowAlert(true);
                      setSeverity("error");
                      setMessage("Please enter a valid amount.");
                      setHeader("Error!");
                    }
                  }}
                  onBlur={() => calculateFee()}
                />
                <Select
                  name="feeDescription"
                  label="Fee Description"
                  value={selectedOption['description'] ?? ""}              
                  onChange={(e) => setSelectedOption((prev) => ({ ...prev, description: e.target.value }))}
                  options={feeDescription}
                />
                <Stack spacing={1} direction="row" className="button-group d-flex justify-content-end mt-3">
                <BaseButton 
                  buttonText={"Submit"} 
                  // disabled={disabled}
                  // onClick={(event) => {handlePostFees(event)}}
                  onClick={(e) => {{pin ? handlePostFees(e, pin) : pinConfiguration === "never" ? handlePostFees(e, '0000') : handleFeeTransfer()}}}
                />
                </Stack>
            </form>
          </Box>
        )}

        <CustomAlert 
          severity={severity} 
          show={showAlert} 
          header={header} 
          message={message} 
          onClick={() => setShowAlert(false)} 
          autoclose={severity === "error" ? false : true} 
        />
        {showPinPad && 
          <PinPad 
            show={showPinPad}
            handleConfirm={handleConfirm} 
            onClick={() => setShowPinPad(false)} 
          />
        }
    </Box>
  );
}

export default Fees;